import React, { Component } from 'react';
import './pages.css';

import Button from './button.js';

require('./Fonts/691970/0a9b9cc6-55eb-4369-97ed-87b3eefd433a.woff2');
require('./Fonts/691979/84e1d9b2-4a5e-42f7-b7bb-e9edadb46977.woff2');

const image1 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521650/animation/a1_ifezc8.png';
const image2 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521650/animation/a2_ulv3th.png';
const image3 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521649/animation/a3_jnfbhr.png';
const image4 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521650/animation/a4_qmfhwb.png';
const image5 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521650/animation/a5_rvhjdk.png';
const image6 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521650/animation/a6_cii6u6.png';
const image7 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521650/animation/a7_iny0vi.png';
const image8 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521650/animation/a8_sfd9rh.png';
const image9 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521650/animation/a9_fi8pq2.png';
const image10 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561521651/animation/a10_z9xder.png';

const allExpandableImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
];

let nextImage, prevImage, clearImage;

const handleKeyDown = (e) => {
    const key = e.keyCode;
    const escape = 27;
    const leftArrow = 37;
    const rightArrow = 39;

    if (key === escape) {
        clearImage && clearImage();
        e.stopPropagation();
        e.preventDefault();
    } else if (key === rightArrow) {
        nextImage && nextImage();
        e.stopPropagation();
        e.preventDefault();
    } else if (key === leftArrow) {
        prevImage && prevImage();
        e.stopPropagation();
        e.preventDefault();
    }
};

class AnimationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
        imageToShow: undefined
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', handleKeyDown);
  }

  render() {
    const { changePage } = this.props;
    const { imageToShow } = this.state;
    const setImage = (image) => {
        this.setState({ imageToShow: image });
    };

    nextImage = () => {
        if (!!imageToShow) {
            const index = allExpandableImages.indexOf(imageToShow);
            setImage(allExpandableImages[(index + 1) % allExpandableImages.length]);
        }
    };

    prevImage = () => {
        if (!!imageToShow) {
            const index = allExpandableImages.indexOf(imageToShow);
            setImage(allExpandableImages[(index + allExpandableImages.length - 1) % allExpandableImages.length]);
        }
    };

    clearImage = () => setImage(undefined);

    return (
      <div>
        <div className={"modal-" + !!imageToShow}>
            <div className="backdrop" onClick={() => setImage(undefined)}></div>
            <img className="image-displayer" src={imageToShow} />
        </div>
        <div className="maincontent">
            <div className="header-bar-small">
                <div className="name-title light">
                    <h1 onClick={() => changePage("main")}>Christina Winchester</h1>
                </div>
                <div className="button-bar-small">
                    <Button changePage={changePage} pageName="character" innerClassName="btn-smaller" containerClassName="character-btn-container" buttonFile={require('./images/buttonc.svg')} caption="Character Design"/>
                    <Button changePage={changePage} pageName="animation" innerClassName="btn-small" containerClassName="animation-btn-container" buttonFile={require('./images/buttona.svg')} caption="Animation"/>
                    <Button changePage={changePage} pageName="graphic" innerClassName="btn-small" containerClassName="graphic-btn-container" buttonFile={require('./images/buttong.svg')} caption="Graphic Design"/>
                    <Button changePage={changePage} pageName="uxui" innerClassName="btn-smaller" containerClassName="uxui-btn-container" buttonFile={require('./images/buttonu.svg')} caption="UX/UI Design"/>
                </div>
            </div>
            <div className="heading-left darker">
                <h1>Animation</h1>
            </div>
            <div className="heading-bar-left">
                <img src={require('./images/animation/ba2.jpg')}/>
            </div>
            <div className="paragraph-left medium">
                From storyboard to a finished project, I have experience with animation spanning between film and game development. It's a handy skill to have!
            </div>
            <div className="worker-cat-animation">
                <video controls loop poster={require('./images/animation/worker-cat-still.png')}>
                    <source src='https://res.cloudinary.com/dvba0h43j/video/upload/v1561521602/animation/worker-cat_lqgz2h.mp4' />
                </video>
            </div>
            <div className="animation-btn-bar">
                <img className="animation-btn-1 clickable" src={require('./images/animation/buttons/ab1.png')} onClick={() => setImage(image1)} />
                <img className="animation-btn-2 clickable" src={require('./images/animation/buttons/ab2.png')} onClick={() => setImage(image2)} />
                <img className="animation-btn-3 clickable" src={require('./images/animation/buttons/ab3.png')} onClick={() => setImage(image3)} />
            </div>
            <div className="storyboarding-section">
                <div className="storyboarding-heading light">
                    <h2>Storyboarding</h2>
                </div>
                <img className="animation-btn-4 clickable" src={require('./images/animation/buttons/ab4.png')} onClick={() => setImage(image4)} />
                <img className="storyboarding-arrow" src={require('./images/animation/whitearrow.svg')} />
                <img className="animation-btn-5 clickable" src={require('./images/animation/buttons/ab5.png')} onClick={() => setImage(image5)} />
                <img className="animation-btn-6 clickable" src={require('./images/animation/buttons/ab6.png')} onClick={() => setImage(image6)} />
                <div className="storyboarding paragraph-left light">
                    <p>The below storyboard is called Fox Delivery Service. It's the story of a fox and his misadventure in trying to deliver a letter.</p>
                    <p>This is a personal project of mine from early 2018.</p>
                </div>
                <div className="storyboards">
                    <img className="animation-btn-7 clickable" src={require('./images/animation/buttons/ab7.png')} onClick={() => setImage(image7)} />
                    <img className="animation-btn-8 clickable" src={require('./images/animation/buttons/ab8.png')} onClick={() => setImage(image8)} />
                    <img className="animation-btn-9 clickable" src={require('./images/animation/buttons/ab9.png')} onClick={() => setImage(image9)} />
                    <img className="animation-btn-10 clickable" src={require('./images/animation/buttons/ab10.png')} onClick={() => setImage(image10)} />
                </div>
            </div>
            <div className="graphic-section">
                <div className="subheading-left darker">
                    <h2><img className="blueflowers" src={require('./images/animation/blueflowers.svg')} />Origami Kami</h2>
                </div>
                <div className="origami-kami-video-container">
                    <iframe className="origami-kami-video" src="https://www.youtube.com/embed/5jPlLAas8iA" />
                </div>
                <div className="centered-full medium">
                    <p>Origami Kami is a video game for the PlayStation Vita. I was the Art Lead, in charge of ensuring that the style and art requirements of the game were being met. All of the 2D art was also created by me, including story screens and UI for the title screen.</p>
                </div>
            </div>
            <img src={require('./images/animation/ba4.jpg')} />
            <div className="copyright-info">
                © Christina Winchester; 2019
            </div>
        </div>
      </div>
    );
  }
}

export default AnimationPage;
